export const ConfirmationModals = {
  AbandonCart: 'abandon-cart',
  TextAlerts: 'text-alerts',
};
